import React from 'react';
import { Link } from 'react-router-dom';

function Instructions() {
  return (
    <div>
      <div className="card">
        <h1 style={{ marginBottom: '20px', color: '#4f46e5' }}>
          📋 Test Instructions - Selective High School Placement Test
        </h1>
        
        <div style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#333' }}>Before You Begin</h2>
          <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#666', marginBottom: '15px' }}>
            Please read these instructions carefully before starting your practice test. 
            Understanding how to use the test platform will help you perform your best.
          </p>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: '#f0f9ff', borderRadius: '8px', borderLeft: '4px solid #4f46e5' }}>
          <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#4f46e5' }}>1. Test Format</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#666' }}>
            <li>Tests contain multiple choice and written answer questions</li>
            <li>Each question must be answered before moving to the next</li>
            <li>You can navigate between questions using Previous/Next buttons</li>
            <li>Your progress is shown at the top of each page</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: '#f0fdf4', borderRadius: '8px', borderLeft: '4px solid #10b981' }}>
          <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#10b981' }}>2. Using PrepSmart Platform</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#666' }}>
            <li><strong>Multiple Choice:</strong> Click on your chosen answer. The selected option will be highlighted.</li>
            <li><strong>Written Answers:</strong> Type your response in the text box provided. Be clear and concise.</li>
            <li><strong>Navigation:</strong> Use the "Previous" and "Next" buttons to move between questions.</li>
            <li><strong>Review:</strong> You can change your answers before submitting the test.</li>
            <li><strong>Submit:</strong> Click "Submit Exam" when you've completed all questions.</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: '#fef3c7', borderRadius: '8px', borderLeft: '4px solid #f59e0b' }}>
          <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#f59e0b' }}>3. Important Tips</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#666' }}>
            <li>Read each question carefully before answering</li>
            <li>Manage your time wisely - note the suggested duration for each test</li>
            <li>For written answers, check your spelling and grammar</li>
            <li>If unsure, make your best attempt - partial credit may be awarded</li>
            <li>Review your answers before final submission</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: '#fef2f2', borderRadius: '8px', borderLeft: '4px solid #ef4444' }}>
          <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#ef4444' }}>4. After Submission</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#666' }}>
            <li>You'll receive instant results with your score</li>
            <li>Instant feedback will explain correct and incorrect answers</li>
            <li>Review the feedback to understand areas for improvement</li>
            <li>You can take the test again to practice and improve</li>
          </ul>
        </div>

        <div style={{ marginBottom: '30px', padding: '20px', background: '#ede9fe', borderRadius: '8px' }}>
          <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#7c3aed' }}>Technical Requirements</h3>
          <ul style={{ paddingLeft: '20px', lineHeight: '1.8', color: '#666' }}>
            <li>Stable internet connection recommended</li>
            <li>Use a modern web browser (Chrome, Firefox, Safari, Edge)</li>
            <li>Ensure JavaScript is enabled</li>
            <li>For best experience, use a desktop or laptop computer</li>
          </ul>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <Link to="/exams">
            <button className="btn-primary" style={{ fontSize: '18px', padding: '16px 40px' }}>
              I Understand - Start Practice Test
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Instructions;
